export default __webpack_public_path__ + "static/media/tv.758951b2.png";